import { AttachmentViewer } from '@affine/core/blocksuite/attachment-viewer';
import type { PDFViewerNavigation } from '@affine/core/blocksuite/attachment-viewer/pdf/pdf-navigation';
import type { AttachmentBlockModel } from '@blocksuite/affine/model';
import { useMemo } from 'react';

import { useEditor } from '../utils';

export type AttachmentPreviewModalProps = {
  docId: string;
  blockId: string;
  navigation?: PDFViewerNavigation;
};

export const AttachmentPreviewPeekView = ({
  docId,
  blockId,
  navigation,
}: AttachmentPreviewModalProps) => {
  const { doc } = useEditor(docId);
  const blocksuiteDoc = doc?.blockSuiteDoc;
  const model = useMemo(
    () => blocksuiteDoc?.getModelById<AttachmentBlockModel>(blockId) ?? null,
    [blockId, blocksuiteDoc]
  );

  if (model) {
    return <AttachmentViewer model={model} navigation={navigation} />;
  }

  return null;
};
